import {
  Button,
  Dropdown,
  DropdownList,
  typographyV2,
} from '@toggle/design-system';
import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  min-width: 0;
  flex: 1;
`;
export const StyledDropdown = styled(Dropdown)`
  ${DropdownList.Styled.DropdownListRoot} {
    width: 230px;
  }
`;

export const HeaderButtons = styled.div`
  display: flex;
  flex-direction: row;
`;

export const DropdownDivider = styled.hr`
  border: 1px solid var(--border-soft);
`;

export const DropdownTrigger = styled(Button)`
  ${Button.Styled.Label} {
    ${typographyV2.titleMd};
  }
  ${Button.Styled.Text} {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    max-width: 180px;
  }
  overflow: hidden;
  justify-content: flex-start;
`;
